export default __webpack_public_path__ + "static/media/whatsapp.10f454d6.svg";